import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';

export type OidcAppState = {
    returnTo?: string;
};

export function createOidcConfig(authority: string, clientId: string): AuthProviderProps {
    return {
        authority,
        client_id: clientId,
        redirect_uri: `${window.location.origin}/auth/callback`,
        response_type: 'code',
        // Use 'oauth' (a scope the server registers), NOT 'openid': this server issues no
        // id_token, but oidc-client-ts enters OIDC mode on the 'openid' scope and then throws
        // decoding the missing id_token. Identity claims live in the access token regardless.
        scope: 'oauth',
        loadUserInfo: false,
        automaticSilentRenew: true,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        // Once the code exchange completes on /auth/callback, strip the OAuth query
        // params from the URL; AuthCallback then navigates to the original location.
        onSigninCallback: () => {
            window.history.replaceState({}, document.title, window.location.pathname);
        },
    };
}
